import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-钻井分析_钻头分析",
  "use": "icon-钻井分析_钻头分析-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-钻井分析_钻头分析\">\n<g>\n\t<g>\n\t\t<path d=\"M10.1,10v0.7l-2.2,2.7l-2.2-2.7V3.4h4.4v3.5l1,0V2.8H4.7v8.4l3.2,3.6l3.2-3.6V10L10.1,10z\" />\n\t</g>\n\t<g>\n\t\t<path d=\"M15,2v0.6H1V2H15 M15.8,1.2H0.2v2.2h15.6V1.2L15.8,1.2z\" />\n\t</g>\n\t<g>\n\t\t<polygon points=\"7.3,9.8 6.9,9.2 9.1,7.5 10.7,8.7 13.5,7 13.9,7.7 10.6,9.7 9.1,8.5 \t\t\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol